import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../lib/auth/AuthContext';

export function Header() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGetStarted = () => {
    if (user) {
      navigate('/dashboard');
    } else {
      navigate('/auth/signup');
    }
  };

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/80 backdrop-blur-lg shadow-soft' : 'bg-transparent'
    }`}>
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <div className="flex items-center space-x-2">
              <div className={`flex h-10 w-10 items-center justify-center rounded-xl transition-all duration-300 ${
                isScrolled ? 'bg-purple-600' : 'bg-purple-600/90 backdrop-blur-sm'
              }`}>
                <img className="h-8 w-8" src="/logo.svg" alt="Bidzora" />
              </div>
              <span className={`text-xl font-bold transition-colors duration-300 ${
                isScrolled ? 'text-purple-600' : 'text-purple-600/90'
              }`}>
                Bidzora
              </span>
            </div>
          </Link>
        </div>
        
        {/* Desktop navigation */}
        <div className="hidden lg:flex lg:gap-x-12">
          <Link to="/features" className="text-sm font-semibold leading-6 text-gray-900">Features</Link>
          <Link to="/pricing" className="text-sm font-semibold leading-6 text-gray-900">Pricing</Link>
          <Link to="/testimonials" className="text-sm font-semibold leading-6 text-gray-900">Testimonials</Link>
          <Link to="/contact-sales" className="text-sm font-semibold leading-6 text-gray-900">Contact Sales</Link>
        </div>

        <div className="hidden lg:flex lg:flex-1 lg:justify-end lg:space-x-4">
          {user ? (
            <Link
              to="/dashboard"
              className="text-sm font-semibold leading-6 text-gray-900"
            >
              Dashboard
            </Link>
          ) : (
            <>
              <Link
                to="/auth/login"
                className="text-sm font-semibold leading-6 text-gray-900 hover:text-purple-600"
              >
                Sign In
              </Link>
              <button
                onClick={handleGetStarted}
                className="rounded-xl bg-purple-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
              >
                Get Started Free
              </button>
            </>
          )}
        </div>

        {/* Mobile menu button */}
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-gray-700"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden absolute inset-x-0 top-full bg-white shadow-lg">
            <div className="space-y-1 px-4 py-4">
              <Link to="/features" className="block px-3 py-2 text-base font-medium text-gray-900">Features</Link>
              <Link to="/pricing" className="block px-3 py-2 text-base font-medium text-gray-900">Pricing</Link>
              <Link to="/testimonials" className="block px-3 py-2 text-base font-medium text-gray-900">Testimonials</Link>
              <Link to="/contact-sales" className="block px-3 py-2 text-base font-medium text-gray-900">Contact Sales</Link>
              <div className="border-t border-gray-200 pt-4">
                {user ? (
                  <Link
                    to="/dashboard"
                    className="block px-3 py-2 text-base font-medium text-gray-900"
                  >
                    Dashboard
                  </Link>
                ) : (
                  <>
                    <Link
                      to="/auth/login"
                      className="block px-3 py-2 text-base font-medium text-gray-900"
                    >
                      Sign In
                    </Link>
                    <button
                      onClick={handleGetStarted}
                      className="mt-2 w-full rounded-xl bg-purple-600 px-3 py-2 text-base font-medium text-white"
                    >
                      Get Started Free
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}